import Java from "./components/Java";
import Java_Abstract from "./components/Java_Abstract";
import Java_Abstraction from "./components/Java_Abstraction";
import Java_Add_Two_Numbers from "./components/Java_Add_Two_Numbers";
import Java_Advanced_Sorting from "./components/Java_Advanced_Sorting";
import Java_Annotations from "./components/Java_Annotations";
import Java_Anonymous from "./components/Java_Anonymous";
import Java_Area_Rectangle from "./components/Java_Area_Rectangle";
import Java_Armstrong_Number from "./components/Java_Armstrong_Number";
import Java_Array from "./components/Java_Array";
import Java_ArrayExamples from "./components/Java_ArrayExamples";
import Java_ArrayList from "./components/Java_ArrayList";
import Java_ArrayList_Loop from "./components/Java_ArrayList_Loop";
import Java_ArrayList_Methods from "./components/Java_ArrayList_Methods";
import Java_ArrayList_add from "./components/Java_ArrayList_add";
import Java_ArrayList_addAll from "./components/Java_ArrayList_addAll";
import Java_ArrayList_clear from "./components/Java_ArrayList_clear";
import Java_ArrayList_clone from "./components/Java_ArrayList_clone";
import Java_ArrayList_contains from "./components/Java_ArrayList_contains";
import Java_ArrayList_ensureCapacity from "./components/Java_ArrayList_ensureCapacity";
import Java_ArrayList_forEach from "./components/Java_ArrayList_forEach";
import Java_ArrayList_get from "./components/Java_ArrayList_get";
import Java_ArrayList_indexOf from "./components/Java_ArrayList_indexOf";
import Java_ArrayList_isEmpty from "./components/Java_ArrayList_isEmpty";
import Java_ArrayList_iterator from "./components/Java_ArrayList_iterator";
import Java_ArrayList_lastIndexOf from "./components/Java_ArrayList_lastIndexOf";
import Java_ArrayList_listIterator from "./components/Java_ArrayList_listIterator";
import Java_ArrayList_remove from "./components/Java_ArrayList_remove";
import Java_ArrayList_removeAll from "./components/Java_ArrayList_removeAll";
import Java_ArrayList_removeIf from "./components/Java_ArrayList_removeIf";
import Java_ArrayList_replaceAll from "./components/Java_ArrayList_replaceAll";
import Java_ArrayList_retainAll from "./components/Java_ArrayList_retainAll";
import Java_ArrayList_set from "./components/Java_ArrayList_set";
import Java_ArrayList_size from "./components/Java_ArrayList_size";
import Java_ArrayList_sort from "./components/Java_ArrayList_sort";
import Java_ArrayList_spliterator from "./components/Java_ArrayList_spliterator";
import Java_ArrayList_subList from "./components/Java_ArrayList_subList";
import Java_ArrayList_toArray from "./components/Java_ArrayList_toArray";
import Java_ArrayList_trimToSize from "./components/Java_ArrayList_trimToSize";
import Java_ArrayLoop from "./components/Java_ArrayLoop";
import Java_Array_Average from "./components/Java_Array_Average";
import Java_Array_Methods from "./components/Java_Array_Methods";
import Java_Arrays_compare from "./components/Java_Arrays_compare";
import Java_Arrays_equals from "./components/Java_Arrays_equals";
import Java_Arrays_fill from "./components/Java_Arrays_fill";
import Java_Arrays_length from "./components/Java_Arrays_length";
import Java_Arrays_sort from "./components/Java_Arrays_sort";
import Java_Assert from "./components/Java_Assert";
import Java_Boolean from "./components/Java_Boolean";
import Java_Booleans from "./components/Java_Booleans";
import Java_Break from "./components/Java_Break";
import Java_Break_Continue from "./components/Java_Break_Continue";
import Java_BufferedReader from "./components/Java_BufferedReader";
import Java_BufferedWriter from "./components/Java_BufferedWriter";
import Java_Byte from "./components/Java_Byte";
import Java_Case from "./components/Java_Case";
import Java_Catch from "./components/Java_Catch";
import Java_Celsius_Fahrenheit from "./components/Java_Celsius_Fahrenheit";
import Java_Char from "./components/Java_Char";
import Java_Char_Frequency from "./components/Java_Char_Frequency";
import Java_Check_Anagram from "./components/Java_Check_Anagram";
import Java_Class from "./components/Java_Class";
import Java_Class_Attributes from "./components/Java_Class_Attributes";
import Java_Class_Methods from "./components/Java_Class_Methods";
import Java_Classes_Objects from "./components/Java_Classes_Objects";
import Java_Collections from "./components/Java_Collections";
import Java_Comments from "./components/Java_Comments";
import Java_Compiler from "./components/Java_Compiler";
import Java_Constructors from "./components/Java_Constructors";
import Java_Continue from "./components/Java_Continue";
import Java_Count_Digits_String from "./components/Java_Count_Digits_String";
import Java_Count_Vowels from "./components/Java_Count_Vowels";
import Java_Count_Words from "./components/Java_Count_Words";
import Java_Create_Write_Files from "./components/Java_Create_Write_Files";
import Java_DataTypes_Booleans from "./components/Java_DataTypes_Booleans";
import Java_DataTypes_Characters from "./components/Java_DataTypes_Characters";
import Java_DataTypes_Example from "./components/Java_DataTypes_Example";
import Java_DataTypes_NonPrimitive from "./components/Java_DataTypes_NonPrimitive";
import Java_DataTypes_Numbers from "./components/Java_DataTypes_Numbers";
import Java_DataTypes_Var from "./components/Java_DataTypes_Var";
import Java_Data_Structures from "./components/Java_Data_Structures";
import Java_Data_Types from "./components/Java_Data_Types";
import Java_Date from "./components/Java_Date";
import Java_Debugging from "./components/Java_Debugging";
import Java_Default from "./components/Java_Default";
import Java_Delete_Files from "./components/Java_Delete_Files";
import Java_Do from "./components/Java_Do";
import Java_DoWhile from "./components/Java_DoWhile";
import Java_Double from "./components/Java_Double";
import Java_Else from "./components/Java_Else";
import Java_ElseIf from "./components/Java_ElseIf";
import Java_Encapsulation from "./components/Java_Encapsulation";
import Java_EnumConstructor from "./components/Java_EnumConstructor";
import Java_EnumKeyword from "./components/Java_EnumKeyword";
import Java_Enum_Loop from "./components/Java_Enum_Loop";
import Java_Enums from "./components/Java_Enums";
import Java_Errors from "./components/Java_Errors";
import Java_Errors_Exceptions from "./components/Java_Errors_Exceptions";
import Java_Even_Odd from "./components/Java_Even_Odd";
import Java_Exceptions from "./components/Java_Exceptions";
import Java_Exercises from "./components/Java_Exercises";
import Java_Exports from "./components/Java_Exports";
import Java_Extends from "./components/Java_Extends";
import Java_Factorial from "./components/Java_Factorial";
import Java_Fibonacci from "./components/Java_Fibonacci";
import Java_FileInputStream from "./components/Java_FileInputStream";
import Java_FileOutputStream from "./components/Java_FileOutputStream";
import Java_File_Methods from "./components/Java_File_Methods";
import Java_Files from "./components/Java_Files";
import Java_Final from "./components/Java_Final";
import Java_Finally from "./components/Java_Finally";
import Java_Find_Duplicates from "./components/Java_Find_Duplicates";
import Java_Float from "./components/Java_Float";
import Java_For from "./components/Java_For";
import Java_ForEach from "./components/Java_ForEach";
import Java_ForLoop_Examples from "./components/Java_ForLoop_Examples";
import Java_For_Loop from "./components/Java_For_Loop";
import Java_GCD from "./components/Java_GCD";
import Java_Generics from "./components/Java_Generics";
import Java_Get_Started from "./components/Java_Get_Started";
import Java_HashMap from "./components/Java_HashMap";
import Java_HashMap_Loop from "./components/Java_HashMap_Loop";
import Java_HashMap_Methods from "./components/Java_HashMap_Methods";
import Java_HashMap_clear from "./components/Java_HashMap_clear";
import Java_HashMap_clone from "./components/Java_HashMap_clone";
import Java_HashMap_compute from "./components/Java_HashMap_compute";
import Java_HashMap_computeIfAbsent from "./components/Java_HashMap_computeIfAbsent";
import Java_HashMap_computeIfPresent from "./components/Java_HashMap_computeIfPresent";
import Java_HashMap_containsKey from "./components/Java_HashMap_containsKey";
import Java_HashMap_containsValue from "./components/Java_HashMap_containsValue";
import Java_HashMap_entrySet from "./components/Java_HashMap_entrySet";
import Java_HashMap_forEach from "./components/Java_HashMap_forEach";
import Java_HashMap_get from "./components/Java_HashMap_get";
import Java_HashMap_getOrDefault from "./components/Java_HashMap_getOrDefault";
import Java_HashMap_isEmpty from "./components/Java_HashMap_isEmpty";
import Java_HashMap_keySet from "./components/Java_HashMap_keySet";
import Java_HashMap_merge from "./components/Java_HashMap_merge";
import Java_HashMap_put from "./components/Java_HashMap_put";
import Java_HashMap_putAll from "./components/Java_HashMap_putAll";
import Java_HashMap_putIfAbsent from "./components/Java_HashMap_putIfAbsent";
import Java_HashMap_remove from "./components/Java_HashMap_remove";
import Java_HashMap_replace from "./components/Java_HashMap_replace";
import Java_HashMap_replaceAll from "./components/Java_HashMap_replaceAll";
import Java_HashMap_size from "./components/Java_HashMap_size";
import Java_HashMap_values from "./components/Java_HashMap_values";
import Java_HashSet from "./components/Java_HashSet";
import Java_Home from "./components/Java_Home";
import Java_How_Tos from "./components/Java_How_Tos";
import Java_IEEEremainder from "./components/Java_IEEEremainder";
import Java_If from "./components/Java_If";
import Java_IfElse_Examples from "./components/Java_IfElse_Examples";
import Java_Implements from "./components/Java_Implements";
import Java_Import from "./components/Java_Import";
import Java_Inheritance from "./components/Java_Inheritance";
import Java_Inner_Classes from "./components/Java_Inner_Classes";
import Java_Instanceof from "./components/Java_Instanceof";
import Java_Int from "./components/Java_Int";
import Java_Interface from "./components/Java_Interface";
import Java_Intro from "./components/Java_Intro";
import Java_Iterator from "./components/Java_Iterator";
import Java_Iterator_Methods from "./components/Java_Iterator_Methods";
import Java_Keywords from "./components/Java_Keywords";
import Java_Lambda from "./components/Java_Lambda";
import Java_Largest_Element from "./components/Java_Largest_Element";
import Java_LinkedHashMap from "./components/Java_LinkedHashMap";
import Java_LinkedHashSet from "./components/Java_LinkedHashSet";
import Java_LinkedList from "./components/Java_LinkedList";
import Java_LinkedList_Methods from "./components/Java_LinkedList_Methods";
import Java_LinkedList_add from "./components/Java_LinkedList_add";
import Java_LinkedList_addAll from "./components/Java_LinkedList_addAll";
import Java_LinkedList_clear from "./components/Java_LinkedList_clear";
import Java_LinkedList_clone from "./components/Java_LinkedList_clone";
import Java_LinkedList_contains from "./components/Java_LinkedList_contains";
import Java_LinkedList_forEach from "./components/Java_LinkedList_forEach";
import Java_LinkedList_get from "./components/Java_LinkedList_get";
import Java_LinkedList_getFirst from "./components/Java_LinkedList_getFirst";
import Java_LinkedList_getLast from "./components/Java_LinkedList_getLast";
import Java_LinkedList_indexOf from "./components/Java_LinkedList_indexOf";
import Java_LinkedList_isEmpty from "./components/Java_LinkedList_isEmpty";
import Java_LinkedList_iterator from "./components/Java_LinkedList_iterator";
import Java_LinkedList_lastIndexOf from "./components/Java_LinkedList_lastIndexOf";
import Java_LinkedList_listIterator from "./components/Java_LinkedList_listIterator";
import Java_LinkedList_remove from "./components/Java_LinkedList_remove";
import Java_LinkedList_removeAll from "./components/Java_LinkedList_removeAll";
import Java_LinkedList_removeFirst from "./components/Java_LinkedList_removeFirst";
import Java_LinkedList_removeIf from "./components/Java_LinkedList_removeIf";
import Java_LinkedList_removeLast from "./components/Java_LinkedList_removeLast";
import Java_LinkedList_replaceAll from "./components/Java_LinkedList_replaceAll";
import Java_LinkedList_retainAll from "./components/Java_LinkedList_retainAll";
import Java_LinkedList_set from "./components/Java_LinkedList_set";
import Java_LinkedList_size from "./components/Java_LinkedList_size";
import Java_LinkedList_sort from "./components/Java_LinkedList_sort";
import Java_LinkedList_spliterator from "./components/Java_LinkedList_spliterator";
import Java_LinkedList_subList from "./components/Java_LinkedList_subList";
import Java_LinkedList_toArray from "./components/Java_LinkedList_toArray";
import Java_List from "./components/Java_List";
import Java_List_Sorting from "./components/Java_List_Sorting";
import Java_LogicalOperators from "./components/Java_LogicalOperators";
import Java_Long from "./components/Java_Long";
import Java_Map from "./components/Java_Map";
import Java_Math from "./components/Java_Math";
import Java_Math_Methods from "./components/Java_Math_Methods";
import Java_Merge_Arrays from "./components/Java_Merge_Arrays";
import Java_Method_Overloading from "./components/Java_Method_Overloading";
import Java_Method_Parameters from "./components/Java_Method_Parameters";
import Java_Methods from "./components/Java_Methods";
import Java_Min_Max_Array from "./components/Java_Min_Max_Array";
import Java_Modifiers from "./components/Java_Modifiers";
import Java_Module from "./components/Java_Module";
import Java_MultiArray from "./components/Java_MultiArray";
import Java_Native from "./components/Java_Native";
import Java_NestedFor from "./components/Java_NestedFor";
import Java_NestedIf from "./components/Java_NestedIf";
import Java_New from "./components/Java_New";
import Java_NonAccessModifiers from "./components/Java_NonAccessModifiers";
import Java_OOP from "./components/Java_OOP";
import Java_Operators from "./components/Java_Operators";
import Java_Operators_Arithmetic from "./components/Java_Operators_Arithmetic";
import Java_Operators_Assignment from "./components/Java_Operators_Assignment";
import Java_Operators_Comparison from "./components/Java_Operators_Comparison";
import Java_Operators_Logical from "./components/Java_Operators_Logical";
import Java_Output from "./components/Java_Output";
import Java_Output_Methods from "./components/Java_Output_Methods";
import Java_Output_PrintNumbers from "./components/Java_Output_PrintNumbers";
import Java_Package from "./components/Java_Package";
import Java_Packages_API from "./components/Java_Packages_API";
import Java_Palindrome_Check from "./components/Java_Palindrome_Check";
import Java_Polymorphism from "./components/Java_Polymorphism";
import Java_Positive_Negative from "./components/Java_Positive_Negative";
import Java_Prime_Check from "./components/Java_Prime_Check";
import Java_Private from "./components/Java_Private";
import Java_Projects from "./components/Java_Projects";
import Java_Protected from "./components/Java_Protected";
import Java_Public from "./components/Java_Public";
import Java_Quiz from "./components/Java_Quiz";
import Java_Random_Number from "./components/Java_Random_Number";
import Java_Read_Files from "./components/Java_Read_Files";
import Java_Recursion from "./components/Java_Recursion";
import Java_Reference from "./components/Java_Reference";
import Java_RegEx from "./components/Java_RegEx";
import Java_Remove_Duplicates from "./components/Java_Remove_Duplicates";
import Java_Remove_Vowels from "./components/Java_Remove_Vowels";
import Java_Remove_Whitespace from "./components/Java_Remove_Whitespace";
import Java_Requires from "./components/Java_Requires";
import Java_Return from "./components/Java_Return";
import Java_ReturnValues from "./components/Java_ReturnValues";
import Java_Reverse_Number from "./components/Java_Reverse_Number";
import Java_Reverse_String from "./components/Java_Reverse_String";
import Java_Scanner_Methods from "./components/Java_Scanner_Methods";
import Java_Scanner_close from "./components/Java_Scanner_close";
import Java_Scanner_delimiter from "./components/Java_Scanner_delimiter";
import Java_Scanner_findInLine from "./components/Java_Scanner_findInLine";
import Java_Scanner_findWithinHorizon from "./components/Java_Scanner_findWithinHorizon";
import Java_Scanner_hasNext from "./components/Java_Scanner_hasNext";
import Java_Scanner_hasNextBoolean from "./components/Java_Scanner_hasNextBoolean";
import Java_Scanner_hasNextByte from "./components/Java_Scanner_hasNextByte";
import Java_Scanner_hasNextDouble from "./components/Java_Scanner_hasNextDouble";
import Java_Scanner_hasNextFloat from "./components/Java_Scanner_hasNextFloat";
import Java_Scanner_hasNextInt from "./components/Java_Scanner_hasNextInt";
import Java_Scanner_hasNextLine from "./components/Java_Scanner_hasNextLine";
import Java_Scanner_hasNextLong from "./components/Java_Scanner_hasNextLong";
import Java_Scanner_hasNextShort from "./components/Java_Scanner_hasNextShort";
import Java_Scanner_locale from "./components/Java_Scanner_locale";
import Java_Scanner_next from "./components/Java_Scanner_next";
import Java_Scanner_nextBoolean from "./components/Java_Scanner_nextBoolean";
import Java_Scanner_nextByte from "./components/Java_Scanner_nextByte";
import Java_Scanner_nextDouble from "./components/Java_Scanner_nextDouble";
import Java_Scanner_nextFloat from "./components/Java_Scanner_nextFloat";
import Java_Scanner_nextInt from "./components/Java_Scanner_nextInt";
import Java_Scanner_nextLine from "./components/Java_Scanner_nextLine";
import Java_Scanner_nextLong from "./components/Java_Scanner_nextLong";
import Java_Scanner_nextShort from "./components/Java_Scanner_nextShort";
import Java_Scanner_radix from "./components/Java_Scanner_radix";
import Java_Scanner_reset from "./components/Java_Scanner_reset";
import Java_Scanner_useDelimiter from "./components/Java_Scanner_useDelimiter";
import Java_Scanner_useLocale from "./components/Java_Scanner_useLocale";
import Java_Scanner_useRadix from "./components/Java_Scanner_useRadix";
import Java_Scope from "./components/Java_Scope";
import Java_Second_Largest_Array from "./components/Java_Second_Largest_Array";
import Java_Set from "./components/Java_Set";
import Java_Short from "./components/Java_Short";
import Java_ShortHand_IfElse from "./components/Java_ShortHand_IfElse";
import Java_Shuffle_Array from "./components/Java_Shuffle_Array";
import Java_Smallest_Element from "./components/Java_Smallest_Element";
import Java_Sort_Array from "./components/Java_Sort_Array";
import Java_Square_Root from "./components/Java_Square_Root";
import Java_Static from "./components/Java_Static";
import Java_String_Methods from "./components/Java_String_Methods";
import Java_String_To_Array from "./components/Java_String_To_Array";
import Java_Strings from "./components/Java_Strings";
import Java_Strings_Concatenation from "./components/Java_Strings_Concatenation";
import Java_Strings_Numbers from "./components/Java_Strings_Numbers";
import Java_Strings_SpecialCharacters from "./components/Java_Strings_SpecialCharacters";
import Java_StudyPlan from "./components/Java_StudyPlan";
import Java_Sum_Array from "./components/Java_Sum_Array";
import Java_Sum_Digits from "./components/Java_Sum_Digits";
import Java_Super from "./components/Java_Super";
import Java_Swap_Two_Variables from "./components/Java_Swap_Two_Variables";
import Java_Switch from "./components/Java_Switch";
import Java_Synchronized from "./components/Java_Synchronized";
import Java_Syntax from "./components/Java_Syntax";
import Java_Syntax_Statements from "./components/Java_Syntax_Statements";
import Java_System_Methods from "./components/Java_System_Methods";
import Java_This from "./components/Java_This";
import Java_Threads from "./components/Java_Threads";
import Java_Throw from "./components/Java_Throw";
import Java_Throws from "./components/Java_Throws";
import Java_Transient from "./components/Java_Transient";
import Java_TreeMap from "./components/Java_TreeMap";
import Java_TreeSet from "./components/Java_TreeSet";
import Java_Try from "./components/Java_Try";
import Java_Type_Casting from "./components/Java_Type_Casting";
import Java_User_Input from "./components/Java_User_Input";
import Java_Var from "./components/Java_Var";
import Java_Variables from "./components/Java_Variables";
import Java_Variables_Constants from "./components/Java_Variables_Constants";
import Java_Variables_Examples from "./components/Java_Variables_Examples";
import Java_Variables_Identifiers from "./components/Java_Variables_Identifiers";
import Java_Variables_Multiple from "./components/Java_Variables_Multiple";
import Java_Variables_Print from "./components/Java_Variables_Print";
import Java_Void from "./components/Java_Void";
import Java_Volatile from "./components/Java_Volatile";
import Java_While from "./components/Java_While";
import Java_WhileLoop_Examples from "./components/Java_WhileLoop_Examples";
import Java_While_Loop from "./components/Java_While_Loop";
import Java_Wrapper from "./components/Java_Wrapper";
import Java_abs from "./components/Java_abs";
import Java_acos from "./components/Java_acos";
import Java_addExact from "./components/Java_addExact";
import Java_asin from "./components/Java_asin";
import Java_atan from "./components/Java_atan";
import Java_atan2 from "./components/Java_atan2";
import Java_cbrt from "./components/Java_cbrt";
import Java_ceil from "./components/Java_ceil";
import Java_charAt from "./components/Java_charAt";
import Java_codePointAt from "./components/Java_codePointAt";
import Java_codePointBefore from "./components/Java_codePointBefore";
import Java_codePointCount from "./components/Java_codePointCount";
import Java_compareTo from "./components/Java_compareTo";
import Java_compareToIgnoreCase from "./components/Java_compareToIgnoreCase";
import Java_concat from "./components/Java_concat";
import Java_contains from "./components/Java_contains";
import Java_contentEquals from "./components/Java_contentEquals";
import Java_copySign from "./components/Java_copySign";
import Java_copyValueOf from "./components/Java_copyValueOf";
import Java_cos from "./components/Java_cos";
import Java_cosh from "./components/Java_cosh";
import Java_decrementExact from "./components/Java_decrementExact";
import Java_endsWith from "./components/Java_endsWith";
import Java_equals from "./components/Java_equals";
import Java_equalsIgnoreCase from "./components/Java_equalsIgnoreCase";
import Java_exp from "./components/Java_exp";
import Java_expm1 from "./components/Java_expm1";
import Java_floor from "./components/Java_floor";
import Java_floorDiv from "./components/Java_floorDiv";
import Java_floorMod from "./components/Java_floorMod";
import Java_format from "./components/Java_format";
import Java_getBytes from "./components/Java_getBytes";
import Java_getChars from "./components/Java_getChars";
import Java_getExponent from "./components/Java_getExponent";
import Java_hashCode from "./components/Java_hashCode";
import Java_hypot from "./components/Java_hypot";
import Java_incrementExact from "./components/Java_incrementExact";
import Java_indexOf from "./components/Java_indexOf";
import Java_isEmpty from "./components/Java_isEmpty";
import Java_join from "./components/Java_join";
import Java_lastIndexOf from "./components/Java_lastIndexOf";
import Java_length from "./components/Java_length";
import Java_log from "./components/Java_log";
import Java_log10 from "./components/Java_log10";
import Java_log1p from "./components/Java_log1p";
import Java_matches from "./components/Java_matches";
import Java_max from "./components/Java_max";
import Java_min from "./components/Java_min";
import Java_multiplyExact from "./components/Java_multiplyExact";
import Java_negateExact from "./components/Java_negateExact";
import Java_nextAfter from "./components/Java_nextAfter";
import Java_nextDown from "./components/Java_nextDown";
import Java_nextUp from "./components/Java_nextUp";
import Java_offsetByCodePoints from "./components/Java_offsetByCodePoints";
import Java_pow from "./components/Java_pow";
import Java_print from "./components/Java_print";
import Java_printf from "./components/Java_printf";
import Java_println from "./components/Java_println";
import Java_random from "./components/Java_random";
import Java_regionMatches from "./components/Java_regionMatches";
import Java_replace from "./components/Java_replace";
import Java_replaceAll from "./components/Java_replaceAll";
import Java_replaceFirst from "./components/Java_replaceFirst";
import Java_rint from "./components/Java_rint";
import Java_round from "./components/Java_round";
import Java_scalb from "./components/Java_scalb";
import Java_signum from "./components/Java_signum";
import Java_sin from "./components/Java_sin";
import Java_sinh from "./components/Java_sinh";
import Java_split from "./components/Java_split";
import Java_sqrt from "./components/Java_sqrt";
import Java_startsWith from "./components/Java_startsWith";
import Java_subSequence from "./components/Java_subSequence";
import Java_substring from "./components/Java_substring";
import Java_subtractExact from "./components/Java_subtractExact";
import Java_tan from "./components/Java_tan";
import Java_tanh from "./components/Java_tanh";
import Java_toCharArray from "./components/Java_toCharArray";
import Java_toDegrees from "./components/Java_toDegrees";
import Java_toIntExact from "./components/Java_toIntExact";
import Java_toLowerCase from "./components/Java_toLowerCase";
import Java_toRadians from "./components/Java_toRadians";
import Java_toString from "./components/Java_toString";
import Java_toUpperCase from "./components/Java_toUpperCase";
import Java_trim from "./components/Java_trim";
import Java_ulp from "./components/Java_ulp";
import Java_valueOf from "./components/Java_valueOf";

const AllJavaComponents = {
  "<Java />": Java,
  "<Java_Abstract />": Java_Abstract,
  "<Java_Abstraction />": Java_Abstraction,
  "<Java_Add_Two_Numbers />": Java_Add_Two_Numbers,
  "<Java_Advanced_Sorting />": Java_Advanced_Sorting,
  "<Java_Annotations />": Java_Annotations,
  "<Java_Anonymous />": Java_Anonymous,
  "<Java_Area_Rectangle />": Java_Area_Rectangle,
  "<Java_Armstrong_Number />": Java_Armstrong_Number,
  "<Java_Array />": Java_Array,
  "<Java_ArrayExamples />": Java_ArrayExamples,
  "<Java_ArrayList />": Java_ArrayList,
  "<Java_ArrayList_Loop />": Java_ArrayList_Loop,
  "<Java_ArrayList_Methods />": Java_ArrayList_Methods,
  "<Java_ArrayList_add />": Java_ArrayList_add,
  "<Java_ArrayList_addAll />": Java_ArrayList_addAll,
  "<Java_ArrayList_clear />": Java_ArrayList_clear,
  "<Java_ArrayList_clone />": Java_ArrayList_clone,
  "<Java_ArrayList_contains />": Java_ArrayList_contains,
  "<Java_ArrayList_ensureCapacity />": Java_ArrayList_ensureCapacity,
  "<Java_ArrayList_forEach />": Java_ArrayList_forEach,
  "<Java_ArrayList_get />": Java_ArrayList_get,
  "<Java_ArrayList_indexOf />": Java_ArrayList_indexOf,
  "<Java_ArrayList_isEmpty />": Java_ArrayList_isEmpty,
  "<Java_ArrayList_iterator />": Java_ArrayList_iterator,
  "<Java_ArrayList_lastIndexOf />": Java_ArrayList_lastIndexOf,
  "<Java_ArrayList_listIterator />": Java_ArrayList_listIterator,
  "<Java_ArrayList_remove />": Java_ArrayList_remove,
  "<Java_ArrayList_removeAll />": Java_ArrayList_removeAll,
  "<Java_ArrayList_removeIf />": Java_ArrayList_removeIf,
  "<Java_ArrayList_replaceAll />": Java_ArrayList_replaceAll,
  "<Java_ArrayList_retainAll />": Java_ArrayList_retainAll,
  "<Java_ArrayList_set />": Java_ArrayList_set,
  "<Java_ArrayList_size />": Java_ArrayList_size,
  "<Java_ArrayList_sort />": Java_ArrayList_sort,
  "<Java_ArrayList_spliterator />": Java_ArrayList_spliterator,
  "<Java_ArrayList_subList />": Java_ArrayList_subList,
  "<Java_ArrayList_toArray />": Java_ArrayList_toArray,
  "<Java_ArrayList_trimToSize />": Java_ArrayList_trimToSize,
  "<Java_ArrayLoop />": Java_ArrayLoop,
  "<Java_Array_Average />": Java_Array_Average,
  "<Java_Array_Methods />": Java_Array_Methods,
  "<Java_Arrays_compare />": Java_Arrays_compare,
  "<Java_Arrays_equals />": Java_Arrays_equals,
  "<Java_Arrays_fill />": Java_Arrays_fill,
  "<Java_Arrays_length />": Java_Arrays_length,
  "<Java_Arrays_sort />": Java_Arrays_sort,
  "<Java_Assert />": Java_Assert,
  "<Java_Boolean />": Java_Boolean,
  "<Java_Booleans />": Java_Booleans,
  "<Java_Break />": Java_Break,
  "<Java_Break_Continue />": Java_Break_Continue,
  "<Java_BufferedReader />": Java_BufferedReader,
  "<Java_BufferedWriter />": Java_BufferedWriter,
  "<Java_Byte />": Java_Byte,
  "<Java_Case />": Java_Case,
  "<Java_Catch />": Java_Catch,
  "<Java_Celsius_Fahrenheit />": Java_Celsius_Fahrenheit,
  "<Java_Char />": Java_Char,
  "<Java_Char_Frequency />": Java_Char_Frequency,
  "<Java_Check_Anagram />": Java_Check_Anagram,
  "<Java_Class />": Java_Class,
  "<Java_Class_Attributes />": Java_Class_Attributes,
  "<Java_Class_Methods />": Java_Class_Methods,
  "<Java_Classes_Objects />": Java_Classes_Objects,
  "<Java_Collections />": Java_Collections,
  "<Java_Comments />": Java_Comments,
  "<Java_Compiler />": Java_Compiler,
  "<Java_Constructors />": Java_Constructors,
  "<Java_Continue />": Java_Continue,
  "<Java_Count_Digits_String />": Java_Count_Digits_String,
  "<Java_Count_Vowels />": Java_Count_Vowels,
  "<Java_Count_Words />": Java_Count_Words,
  "<Java_Create_Write_Files />": Java_Create_Write_Files,
  "<Java_DataTypes_Booleans />": Java_DataTypes_Booleans,
  "<Java_DataTypes_Characters />": Java_DataTypes_Characters,
  "<Java_DataTypes_Example />": Java_DataTypes_Example,
  "<Java_DataTypes_NonPrimitive />": Java_DataTypes_NonPrimitive,
  "<Java_DataTypes_Numbers />": Java_DataTypes_Numbers,
  "<Java_DataTypes_Var />": Java_DataTypes_Var,
  "<Java_Data_Structures />": Java_Data_Structures,
  "<Java_Data_Types />": Java_Data_Types,
  "<Java_Date />": Java_Date,
  "<Java_Debugging />": Java_Debugging,
  "<Java_Default />": Java_Default,
  "<Java_Delete_Files />": Java_Delete_Files,
  "<Java_Do />": Java_Do,
  "<Java_DoWhile />": Java_DoWhile,
  "<Java_Double />": Java_Double,
  "<Java_Else />": Java_Else,
  "<Java_ElseIf />": Java_ElseIf,
  "<Java_Encapsulation />": Java_Encapsulation,
  "<Java_EnumConstructor />": Java_EnumConstructor,
  "<Java_EnumKeyword />": Java_EnumKeyword,
  "<Java_Enum_Loop />": Java_Enum_Loop,
  "<Java_Enums />": Java_Enums,
  "<Java_Errors />": Java_Errors,
  "<Java_Errors_Exceptions />": Java_Errors_Exceptions,
  "<Java_Even_Odd />": Java_Even_Odd,
  "<Java_Exceptions />": Java_Exceptions,
  "<Java_Exercises />": Java_Exercises,
  "<Java_Exports />": Java_Exports,
  "<Java_Extends />": Java_Extends,
  "<Java_Factorial />": Java_Factorial,
  "<Java_Fibonacci />": Java_Fibonacci,
  "<Java_FileInputStream />": Java_FileInputStream,
  "<Java_FileOutputStream />": Java_FileOutputStream,
  "<Java_File_Methods />": Java_File_Methods,
  "<Java_Files />": Java_Files,
  "<Java_Final />": Java_Final,
  "<Java_Finally />": Java_Finally,
  "<Java_Find_Duplicates />": Java_Find_Duplicates,
  "<Java_Float />": Java_Float,
  "<Java_For />": Java_For,
  "<Java_ForEach />": Java_ForEach,
  "<Java_ForLoop_Examples />": Java_ForLoop_Examples,
  "<Java_For_Loop />": Java_For_Loop,
  "<Java_GCD />": Java_GCD,
  "<Java_Generics />": Java_Generics,
  "<Java_Get_Started />": Java_Get_Started,
  "<Java_HashMap />": Java_HashMap,
  "<Java_HashMap_Loop />": Java_HashMap_Loop,
  "<Java_HashMap_Methods />": Java_HashMap_Methods,
  "<Java_HashMap_clear />": Java_HashMap_clear,
  "<Java_HashMap_clone />": Java_HashMap_clone,
  "<Java_HashMap_compute />": Java_HashMap_compute,
  "<Java_HashMap_computeIfAbsent />": Java_HashMap_computeIfAbsent,
  "<Java_HashMap_computeIfPresent />": Java_HashMap_computeIfPresent,
  "<Java_HashMap_containsKey />": Java_HashMap_containsKey,
  "<Java_HashMap_containsValue />": Java_HashMap_containsValue,
  "<Java_HashMap_entrySet />": Java_HashMap_entrySet,
  "<Java_HashMap_forEach />": Java_HashMap_forEach,
  "<Java_HashMap_get />": Java_HashMap_get,
  "<Java_HashMap_getOrDefault />": Java_HashMap_getOrDefault,
  "<Java_HashMap_isEmpty />": Java_HashMap_isEmpty,
  "<Java_HashMap_keySet />": Java_HashMap_keySet,
  "<Java_HashMap_merge />": Java_HashMap_merge,
  "<Java_HashMap_put />": Java_HashMap_put,
  "<Java_HashMap_putAll />": Java_HashMap_putAll,
  "<Java_HashMap_putIfAbsent />": Java_HashMap_putIfAbsent,
  "<Java_HashMap_remove />": Java_HashMap_remove,
  "<Java_HashMap_replace />": Java_HashMap_replace,
  "<Java_HashMap_replaceAll />": Java_HashMap_replaceAll,
  "<Java_HashMap_size />": Java_HashMap_size,
  "<Java_HashMap_values />": Java_HashMap_values,
  "<Java_HashSet />": Java_HashSet,
  "<Java_Home />": Java_Home,
  "<Java_How_Tos />": Java_How_Tos,
  "<Java_IEEEremainder />": Java_IEEEremainder,
  "<Java_If />": Java_If,
  "<Java_IfElse_Examples />": Java_IfElse_Examples,
  "<Java_Implements />": Java_Implements,
  "<Java_Import />": Java_Import,
  "<Java_Inheritance />": Java_Inheritance,
  "<Java_Inner_Classes />": Java_Inner_Classes,
  "<Java_Instanceof />": Java_Instanceof,
  "<Java_Int />": Java_Int,
  "<Java_Interface />": Java_Interface,
  "<Java_Intro />": Java_Intro,
  "<Java_Iterator />": Java_Iterator,
  "<Java_Iterator_Methods />": Java_Iterator_Methods,
  "<Java_Keywords />": Java_Keywords,
  "<Java_Lambda />": Java_Lambda,
  "<Java_Largest_Element />": Java_Largest_Element,
  "<Java_LinkedHashMap />": Java_LinkedHashMap,
  "<Java_LinkedHashSet />": Java_LinkedHashSet,
  "<Java_LinkedList />": Java_LinkedList,
  "<Java_LinkedList_Methods />": Java_LinkedList_Methods,
  "<Java_LinkedList_add />": Java_LinkedList_add,
  "<Java_LinkedList_addAll />": Java_LinkedList_addAll,
  "<Java_LinkedList_clear />": Java_LinkedList_clear,
  "<Java_LinkedList_clone />": Java_LinkedList_clone,
  "<Java_LinkedList_contains />": Java_LinkedList_contains,
  "<Java_LinkedList_forEach />": Java_LinkedList_forEach,
  "<Java_LinkedList_get />": Java_LinkedList_get,
  "<Java_LinkedList_getFirst />": Java_LinkedList_getFirst,
  "<Java_LinkedList_getLast />": Java_LinkedList_getLast,
  "<Java_LinkedList_indexOf />": Java_LinkedList_indexOf,
  "<Java_LinkedList_isEmpty />": Java_LinkedList_isEmpty,
  "<Java_LinkedList_iterator />": Java_LinkedList_iterator,
  "<Java_LinkedList_lastIndexOf />": Java_LinkedList_lastIndexOf,
  "<Java_LinkedList_listIterator />": Java_LinkedList_listIterator,
  "<Java_LinkedList_remove />": Java_LinkedList_remove,
  "<Java_LinkedList_removeAll />": Java_LinkedList_removeAll,
  "<Java_LinkedList_removeFirst />": Java_LinkedList_removeFirst,
  "<Java_LinkedList_removeIf />": Java_LinkedList_removeIf,
  "<Java_LinkedList_removeLast />": Java_LinkedList_removeLast,
  "<Java_LinkedList_replaceAll />": Java_LinkedList_replaceAll,
  "<Java_LinkedList_retainAll />": Java_LinkedList_retainAll,
  "<Java_LinkedList_set />": Java_LinkedList_set,
  "<Java_LinkedList_size />": Java_LinkedList_size,
  "<Java_LinkedList_sort />": Java_LinkedList_sort,
  "<Java_LinkedList_spliterator />": Java_LinkedList_spliterator,
  "<Java_LinkedList_subList />": Java_LinkedList_subList,
  "<Java_LinkedList_toArray />": Java_LinkedList_toArray,
  "<Java_List />": Java_List,
  "<Java_List_Sorting />": Java_List_Sorting,
  "<Java_LogicalOperators />": Java_LogicalOperators,
  "<Java_Long />": Java_Long,
  "<Java_Map />": Java_Map,
  "<Java_Math />": Java_Math,
  "<Java_Math_Methods />": Java_Math_Methods,
  "<Java_Merge_Arrays />": Java_Merge_Arrays,
  "<Java_Method_Overloading />": Java_Method_Overloading,
  "<Java_Method_Parameters />": Java_Method_Parameters,
  "<Java_Methods />": Java_Methods,
  "<Java_Min_Max_Array />": Java_Min_Max_Array,
  "<Java_Modifiers />": Java_Modifiers,
  "<Java_Module />": Java_Module,
  "<Java_MultiArray />": Java_MultiArray,
  "<Java_Native />": Java_Native,
  "<Java_NestedFor />": Java_NestedFor,
  "<Java_NestedIf />": Java_NestedIf,
  "<Java_New />": Java_New,
  "<Java_NonAccessModifiers />": Java_NonAccessModifiers,
  "<Java_OOP />": Java_OOP,
  "<Java_Operators />": Java_Operators,
  "<Java_Operators_Arithmetic />": Java_Operators_Arithmetic,
  "<Java_Operators_Assignment />": Java_Operators_Assignment,
  "<Java_Operators_Comparison />": Java_Operators_Comparison,
  "<Java_Operators_Logical />": Java_Operators_Logical,
  "<Java_Output />": Java_Output,
  "<Java_Output_Methods />": Java_Output_Methods,
  "<Java_Output_PrintNumbers />": Java_Output_PrintNumbers,
  "<Java_Package />": Java_Package,
  "<Java_Packages_API />": Java_Packages_API,
  "<Java_Palindrome_Check />": Java_Palindrome_Check,
  "<Java_Polymorphism />": Java_Polymorphism,
  "<Java_Positive_Negative />": Java_Positive_Negative,
  "<Java_Prime_Check />": Java_Prime_Check,
  "<Java_Private />": Java_Private,
  "<Java_Projects />": Java_Projects,
  "<Java_Protected />": Java_Protected,
  "<Java_Public />": Java_Public,
  "<Java_Quiz />": Java_Quiz,
  "<Java_Random_Number />": Java_Random_Number,
  "<Java_Read_Files />": Java_Read_Files,
  "<Java_Recursion />": Java_Recursion,
  "<Java_Reference />": Java_Reference,
  "<Java_RegEx />": Java_RegEx,
  "<Java_Remove_Duplicates />": Java_Remove_Duplicates,
  "<Java_Remove_Vowels />": Java_Remove_Vowels,
  "<Java_Remove_Whitespace />": Java_Remove_Whitespace,
  "<Java_Requires />": Java_Requires,
  "<Java_Return />": Java_Return,
  "<Java_ReturnValues />": Java_ReturnValues,
  "<Java_Reverse_Number />": Java_Reverse_Number,
  "<Java_Reverse_String />": Java_Reverse_String,
  "<Java_Scanner_Methods />": Java_Scanner_Methods,
  "<Java_Scanner_close />": Java_Scanner_close,
  "<Java_Scanner_delimiter />": Java_Scanner_delimiter,
  "<Java_Scanner_findInLine />": Java_Scanner_findInLine,
  "<Java_Scanner_findWithinHorizon />": Java_Scanner_findWithinHorizon,
  "<Java_Scanner_hasNext />": Java_Scanner_hasNext,
  "<Java_Scanner_hasNextBoolean />": Java_Scanner_hasNextBoolean,
  "<Java_Scanner_hasNextByte />": Java_Scanner_hasNextByte,
  "<Java_Scanner_hasNextDouble />": Java_Scanner_hasNextDouble,
  "<Java_Scanner_hasNextFloat />": Java_Scanner_hasNextFloat,
  "<Java_Scanner_hasNextInt />": Java_Scanner_hasNextInt,
  "<Java_Scanner_hasNextLine />": Java_Scanner_hasNextLine,
  "<Java_Scanner_hasNextLong />": Java_Scanner_hasNextLong,
  "<Java_Scanner_hasNextShort />": Java_Scanner_hasNextShort,
  "<Java_Scanner_locale />": Java_Scanner_locale,
  "<Java_Scanner_next />": Java_Scanner_next,
  "<Java_Scanner_nextBoolean />": Java_Scanner_nextBoolean,
  "<Java_Scanner_nextByte />": Java_Scanner_nextByte,
  "<Java_Scanner_nextDouble />": Java_Scanner_nextDouble,
  "<Java_Scanner_nextFloat />": Java_Scanner_nextFloat,
  "<Java_Scanner_nextInt />": Java_Scanner_nextInt,
  "<Java_Scanner_nextLine />": Java_Scanner_nextLine,
  "<Java_Scanner_nextLong />": Java_Scanner_nextLong,
  "<Java_Scanner_nextShort />": Java_Scanner_nextShort,
  "<Java_Scanner_radix />": Java_Scanner_radix,
  "<Java_Scanner_reset />": Java_Scanner_reset,
  "<Java_Scanner_useDelimiter />": Java_Scanner_useDelimiter,
  "<Java_Scanner_useLocale />": Java_Scanner_useLocale,
  "<Java_Scanner_useRadix />": Java_Scanner_useRadix,
  "<Java_Scope />": Java_Scope,
  "<Java_Second_Largest_Array />": Java_Second_Largest_Array,
  "<Java_Set />": Java_Set,
  "<Java_Short />": Java_Short,
  "<Java_ShortHand_IfElse />": Java_ShortHand_IfElse,
  "<Java_Shuffle_Array />": Java_Shuffle_Array,
  "<Java_Smallest_Element />": Java_Smallest_Element,
  "<Java_Sort_Array />": Java_Sort_Array,
  "<Java_Square_Root />": Java_Square_Root,
  "<Java_Static />": Java_Static,
  "<Java_String_Methods />": Java_String_Methods,
  "<Java_String_To_Array />": Java_String_To_Array,
  "<Java_Strings />": Java_Strings,
  "<Java_Strings_Concatenation />": Java_Strings_Concatenation,
  "<Java_Strings_Numbers />": Java_Strings_Numbers,
  "<Java_Strings_SpecialCharacters />": Java_Strings_SpecialCharacters,
  "<Java_StudyPlan />": Java_StudyPlan,
  "<Java_Sum_Array />": Java_Sum_Array,
  "<Java_Sum_Digits />": Java_Sum_Digits,
  "<Java_Super />": Java_Super,
  "<Java_Swap_Two_Variables />": Java_Swap_Two_Variables,
  "<Java_Switch />": Java_Switch,
  "<Java_Synchronized />": Java_Synchronized,
  "<Java_Syntax />": Java_Syntax,
  "<Java_Syntax_Statements />": Java_Syntax_Statements,
  "<Java_System_Methods />": Java_System_Methods,
  "<Java_This />": Java_This,
  "<Java_Threads />": Java_Threads,
  "<Java_Throw />": Java_Throw,
  "<Java_Throws />": Java_Throws,
  "<Java_Transient />": Java_Transient,
  "<Java_TreeMap />": Java_TreeMap,
  "<Java_TreeSet />": Java_TreeSet,
  "<Java_Try />": Java_Try,
  "<Java_Type_Casting />": Java_Type_Casting,
  "<Java_User_Input />": Java_User_Input,
  "<Java_Var />": Java_Var,
  "<Java_Variables />": Java_Variables,
  "<Java_Variables_Constants />": Java_Variables_Constants,
  "<Java_Variables_Examples />": Java_Variables_Examples,
  "<Java_Variables_Identifiers />": Java_Variables_Identifiers,
  "<Java_Variables_Multiple />": Java_Variables_Multiple,
  "<Java_Variables_Print />": Java_Variables_Print,
  "<Java_Void />": Java_Void,
  "<Java_Volatile />": Java_Volatile,
  "<Java_While />": Java_While,
  "<Java_WhileLoop_Examples />": Java_WhileLoop_Examples,
  "<Java_While_Loop />": Java_While_Loop,
  "<Java_Wrapper />": Java_Wrapper,
  "<Java_abs />": Java_abs,
  "<Java_acos />": Java_acos,
  "<Java_addExact />": Java_addExact,
  "<Java_asin />": Java_asin,
  "<Java_atan />": Java_atan,
  "<Java_atan2 />": Java_atan2,
  "<Java_cbrt />": Java_cbrt,
  "<Java_ceil />": Java_ceil,
  "<Java_charAt />": Java_charAt,
  "<Java_codePointAt />": Java_codePointAt,
  "<Java_codePointBefore />": Java_codePointBefore,
  "<Java_codePointCount />": Java_codePointCount,
  "<Java_compareTo />": Java_compareTo,
  "<Java_compareToIgnoreCase />": Java_compareToIgnoreCase,
  "<Java_concat />": Java_concat,
  "<Java_contains />": Java_contains,
  "<Java_contentEquals />": Java_contentEquals,
  "<Java_copySign />": Java_copySign,
  "<Java_copyValueOf />": Java_copyValueOf,
  "<Java_cos />": Java_cos,
  "<Java_cosh />": Java_cosh,
  "<Java_decrementExact />": Java_decrementExact,
  "<Java_endsWith />": Java_endsWith,
  "<Java_equals />": Java_equals,
  "<Java_equalsIgnoreCase />": Java_equalsIgnoreCase,
  "<Java_exp />": Java_exp,
  "<Java_expm1 />": Java_expm1,
  "<Java_floor />": Java_floor,
  "<Java_floorDiv />": Java_floorDiv,
  "<Java_floorMod />": Java_floorMod,
  "<Java_format />": Java_format,
  "<Java_getBytes />": Java_getBytes,
  "<Java_getChars />": Java_getChars,
  "<Java_getExponent />": Java_getExponent,
  "<Java_hashCode />": Java_hashCode,
  "<Java_hypot />": Java_hypot,
  "<Java_incrementExact />": Java_incrementExact,
  "<Java_indexOf />": Java_indexOf,
  "<Java_isEmpty />": Java_isEmpty,
  "<Java_join />": Java_join,
  "<Java_lastIndexOf />": Java_lastIndexOf,
  "<Java_length />": Java_length,
  "<Java_log />": Java_log,
  "<Java_log10 />": Java_log10,
  "<Java_log1p />": Java_log1p,
  "<Java_matches />": Java_matches,
  "<Java_max />": Java_max,
  "<Java_min />": Java_min,
  "<Java_multiplyExact />": Java_multiplyExact,
  "<Java_negateExact />": Java_negateExact,
  "<Java_nextAfter />": Java_nextAfter,
  "<Java_nextDown />": Java_nextDown,
  "<Java_nextUp />": Java_nextUp,
  "<Java_offsetByCodePoints />": Java_offsetByCodePoints,
  "<Java_pow />": Java_pow,
  "<Java_print />": Java_print,
  "<Java_printf />": Java_printf,
  "<Java_println />": Java_println,
  "<Java_random />": Java_random,
  "<Java_regionMatches />": Java_regionMatches,
  "<Java_replace />": Java_replace,
  "<Java_replaceAll />": Java_replaceAll,
  "<Java_replaceFirst />": Java_replaceFirst,
  "<Java_rint />": Java_rint,
  "<Java_round />": Java_round,
  "<Java_scalb />": Java_scalb,
  "<Java_signum />": Java_signum,
  "<Java_sin />": Java_sin,
  "<Java_sinh />": Java_sinh,
  "<Java_split />": Java_split,
  "<Java_sqrt />": Java_sqrt,
  "<Java_startsWith />": Java_startsWith,
  "<Java_subSequence />": Java_subSequence,
  "<Java_substring />": Java_substring,
  "<Java_subtractExact />": Java_subtractExact,
  "<Java_tan />": Java_tan,
  "<Java_tanh />": Java_tanh,
  "<Java_toCharArray />": Java_toCharArray,
  "<Java_toDegrees />": Java_toDegrees,
  "<Java_toIntExact />": Java_toIntExact,
  "<Java_toLowerCase />": Java_toLowerCase,
  "<Java_toRadians />": Java_toRadians,
  "<Java_toString />": Java_toString,
  "<Java_toUpperCase />": Java_toUpperCase,
  "<Java_trim />": Java_trim,
  "<Java_ulp />": Java_ulp,
  "<Java_valueOf />": Java_valueOf,
};

export default AllJavaComponents;
